const KEY = {
  KEY_GOOGLE: "190122352939-c8kofm33t70hptpk1sl4m5q73mendvv0.apps.googleusercontent.com",
  KEY_FACEBOOK: "485510280628504"
}

export default KEY
